<template>
    <div>
        <top-navbar></top-navbar>
<div>
  

<div class="mb-5 background_color">
  <h6 class="manage-boder pt-2 font1  decoration"> <a class="decoration" to="/issuetracking/index"> Home </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/issuetracking/index"> Issue Tracking </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>  {{response.sub_ticket_number}}   </h6>


 


  <div class="container-fluid">
 
    <div class="card custom_bdr_rds shadow p-2" v-if="isLoading">
                  <div class="card-body custom_bdr_rds">

                <div class="d-flex justify-content-center" >
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>

                  </div>
                </div>

                <div v-else class="mt-1">
                <div >


  <b-modal :id="infoModal5.id" 
  
  size="sm" hide-footer
   class="top-modal"> 
  <div>
     <!-- <img :src="infoModal5.content" alt="Uploaded Image 1" width="100%" /> -->
     <img  :src="'https://storage.googleapis.com/swipetaskv2/' + encodeURIComponent(infoModal5.content)" alt="Before Image"   width="100%"/>
  </div>
 </b-modal>

                <div class="card custom_bdr_rds shadow p-2">
                <div  class="card-body custom_bdr_rds">


    <table style="font-size: small; " class="table table-hover  table-sm table-borderless   ">
       
          <tbody>

            
            <tr>
              <td style="width: 25%;"><b> {{language[14]['Ticket Number']}}</b></td>
             <td>{{response.ticket_number}}</td> 
           
            </tr>

 



            <tr>
              <td><b>{{language[32]['Sub Ticket Number']}}</b></td>
             <td> {{response.sub_ticket_number}}</td> 
           
            </tr>
           
            <tr>
              <td><b>Tast Tittle</b></td>
             <td>{{response.task_title}}</td> 
         
            </tr>
            
          
            <tr>
              <td><b>{{ language[16]['Main Category'] }}</b></td>
             <td>{{response.category}}</td> 
            
            </tr>
            <tr>
              <td><b>{{ language[17]['Sub Category'] }}</b></td>
             <td>{{response.sub_category}}</td> 
         
            </tr>
    



            <tr>
              <td><b>{{language[22]['Status']}}</b></td>
             <td>{{response.issue_status}}</td> 
       
            </tr>
           
            <tr>
              <td><b>{{language[20]['Address']}} </b></td>
             <td>{{response.location_name}}</td> 
            
            </tr>
            <tr>
              <td><b>{{language[21]['Description']}} </b></td>
             <td>{{response.description}}</td> 
            
            </tr>
            <tr>
              <td><b>Notes </b></td>
             <td>{{response.notes}}</td> 
            
            </tr>
            <tr>
              <td><b>{{language[15]['Citizen Name']}}  </b></td>
             <td>{{response.citizen_name}}</td> 
            
            </tr>
            <tr>
              <td><b>{{language[18]['Citizen Mobile']}} </b></td>
             <td>{{response.citizen_mobile}}</td> 
            
            </tr>
            <tr>
              <td><b>{{language[19]['Citizen Email']}} </b></td>
             <td>{{response.citizen_email}}</td> 
            
            </tr>

            <tr>
              <td><b>Actual start Date </b></td>
             <td>{{response.actual_start_datetime}}</td> 
            
            </tr>
            <tr>
              <td><b>Actual End Date  </b></td>
             <td>{{response.actual_end_datetime}}</td> 
            
            </tr>
            <tr>
              <td><b>Start Date </b></td>
             <td>{{response.start_date}}</td> 
            
            </tr>
            <tr>
              <td><b>End Date </b></td>
             <td>{{response.end_date}}</td> 
            
            </tr>




  
            <tr v-for="(before_image, index) in response.before_images" :key="before_image.id" v-if="before_image.image_name">
              <td>Before Image {{ index + 1 }}</td>
              <td>
                <a style="cursor:pointer"  @click="imageLoad3(before_image.image_name)" >
               
                <img :src="'https://storage.googleapis.com/swipetaskv2/' + encodeURIComponent(before_image.image_name)" alt="Before Image" />
              </a>
              </td>
            </tr>

            <tr v-for="(after_image, index) in response.after_images" :key="after_image.id" v-if="after_image.image_name">
              <td>After Image {{ index + 1 }}</td>
              <td>
                <a style="cursor:pointer"  @click="imageLoad3(after_image.image_name)" >
                <img :src="'https://storage.googleapis.com/swipetaskv2/' + encodeURIComponent(after_image.image_name)" alt="Before Image" width="10%" />
                </a>
              </td>
            </tr>


       
          
            
           
            
          
           
           
             
          </tbody>


        </table>
       


        </div>
        </div>


        <div class="card custom_bdr_rds shadow p-2">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>Contractor Details </b></h6>

                        <div class="table-responsive">
                      
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                            <thead class="background_color2" >
                              <tr class="custom-label2">
                             
                              <th>{{language[49]['First name']}}  </th>
                              <th>{{language[100]['Last name']}}</th>
                              <th>{{language[75]['Mobile']}} </th>
                              <th>{{language[76]['Email']}} </th>
                          
                           
                            
                              </tr>
                            </thead>
                            <tbody> 
                              <tr >
                            
                                <td>{{ response.contractor.first_name }}</td>
                                <td>{{ response.contractor.last_name }}</td>
                                <td>{{ response.contractor.phone_number }}</td>
                                <td>{{ response.contractor.email }}</td>
                              
                              </tr>
                             
                            </tbody>

                          </table>
    
                        </div>
                      </div>
                      </div>



                


       
                   


   
    

    




</div>
</div>
</div>
<br><br><br>
</div>









</div>






        
        <content-footer></content-footer>
    </div>
</template>
<script>
 import axios from 'axios';
 import httpClient from '@/axios';
 import authService from '@/auth.service';
  import TopNavbar from './../../layout/TopNavbar.vue'
  import ContentFooter from './../../layout/ContentFooter.vue'

  export default {
    data() {
      return {
        access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        language:JSON.parse(authService.isLanguage()),
        'id':this.$route.query.id,
        
        issue:{},
        response:{},
        contractors:[],
        isLoading:true,
       
        infoModal5: {
          id: 'info-modal5',
          title: '',
          content: [],
        },


        
      }

    },
    mounted(){
 
  this.loadCrm();
    },

    computed: {
    roundToTwoDecimal() {
      return detail => parseFloat(detail).toFixed(2);
    }
  },
methods : {

  async imageLoad3(id){

this.infoModal5.content = id;
console.log(this.infoModal5.content);
this.$root.$emit('bv::show::modal', this.infoModal5.id);

},
  formatDate(dateString) {
    const date = new Date(dateString); // Create a new Date object from the string

    // Manually format the date as DD-MM-YYYY with dashes
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();

    const formattedDate = `${day}-${month}-${year}`; // Combine date as DD-MM-YYYY
    
    // Format the time as HH:MM in 24-hour format
    const formattedTime = date.toLocaleTimeString('en-GB', {  
      hour: '2-digit', minute: '2-digit'
    });

    return `${formattedDate} ${formattedTime}`;  // Combine date and time
  },
      


  
  
  async loadCrm() {
   
    try {
      const { data} = await  httpClient.get('/web/api/issuetracking/loadsweepdata?id='+this.id,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
      this.response = data.response;
      //  this.contractors = data.contractors;
        this.isLoading= false;
      
    } catch (error) {
      console.log(error.response);
    }
  },



},

    components :{
        ContentFooter,
        TopNavbar
    },
  }

</script>
<style >

</style>